(() => {
  'use strict';

  const groups = [
    {
      title: 'Children’s Wear',
      links: [
        ['Shop all Children’s Wear', '/collections/childrens-uniforms'],
        ['Children’s T-Shirts', '/collections/childrens-t-shirts'],
        ['Children’s Hoodies', '/collections/childrens-hoodies'],
        ['Children’s Fleeces', '/collections/childrens-fleeces'],
        ['Children’s Headwear', '/collections/childrens-headwear']
      ]
    },
    {
      title: 'Sustainable Workwear',
      links: [
        ['Shop all Sustainable Workwear', '/collections/sustainable-workwear'],
        ['Sustainable T-Shirts', '/collections/sustainable-t-shirts'],
        ['Sustainable Polo Shirts', '/collections/sustainable-polo-shirts'],
        ['Sustainable Shirts', '/collections/sustainable-shirts'],
        ['Sustainable Hoodies', '/collections/sustainable-hoodies'],
        ['Sustainable Sweatshirts', '/collections/sustainable-sweatshirts'],
        ['Sustainable Fleeces', '/collections/sustainable-fleeces'],
        ['Sustainable Jackets', '/collections/sustainable-jackets'],
        ['Sustainable Trousers', '/collections/sustainable-trousers'],
        ['Sustainable Aprons', '/collections/sustainable-aprons']
      ]
    }
  ];

  function addDesktopGroups() {
    const directory = document.querySelector('.lmu-mega--products .lmu-product-directory');
    if (!directory || directory.dataset.lmuExtraGroups === '1') return;
    directory.dataset.lmuExtraGroups = '1';

    groups.forEach((group) => {
      const block = document.createElement('div');
      block.className = 'lmu-product-directory__group';

      const heading = document.createElement('h4');
      heading.textContent = group.title;
      block.appendChild(heading);

      group.links.forEach(([label, href]) => {
        const link = document.createElement('a');
        link.href = href;
        link.textContent = label;
        block.appendChild(link);
      });

      directory.appendChild(block);
    });
  }

  function addMobileGroups() {
    const container = document.querySelector('.lmu-mobile-nav__product-links');
    if (!container || container.dataset.lmuExtraGroups === '1') return;
    container.dataset.lmuExtraGroups = '1';

    groups.forEach((group) => {
      const details = document.createElement('details');
      details.className = 'lmu-mobile-nav__product-group';

      const summary = document.createElement('summary');
      summary.textContent = group.title;
      details.appendChild(summary);

      const links = document.createElement('div');
      group.links.forEach(([label, href]) => {
        const link = document.createElement('a');
        link.href = href;
        link.textContent = label;
        links.appendChild(link);
      });
      details.appendChild(links);
      container.appendChild(details);
    });
  }

  addDesktopGroups();
  addMobileGroups();
})();
